import React, { useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { ConversationMessage } from './types';
import { ConversationMessageComponent } from './ConversationMessage';

const useStyles = makeStyles(theme => ({
  conversationContainer: {
    marginBottom: theme.spacing(2),
    maxHeight: '450px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}));

interface ConversationHistoryProps {
  messages: ConversationMessage[];
}

export const ConversationHistory: React.FC<ConversationHistoryProps> = ({
  messages,
}) => {
  const classes = useStyles();
  const containerRef = useRef<HTMLDivElement>(null);

  // Auto-scroll to bottom when messages change
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [messages]);

  if (messages.length === 0) {
    return null;
  }

  return (
    <div className={classes.conversationContainer} ref={containerRef}>
      {messages.map((message) => (
        <ConversationMessageComponent
          key={message.messageId}
          message={message}
        />
      ))}
    </div>
  );
};
